import { inject, unref } from 'vue'

export const PLATFORM_LIST_KEY = Symbol('platformList')

export function usePlatformListContext() {
	const ctx = inject(PLATFORM_LIST_KEY)
	if (!ctx) {
		throw new Error('usePlatformListContext() must be used inside PlatformList')
	}
	return ctx
}

export function unwrapCtx(ctx, key) {
	return unref(ctx[key])
}
